import { ActionDataType } from '../BaseCustomAction';
import {
  BaseQuestionGeneration,
  QUESTION_ACTION_TAGS,
  QuestionGenerationInputData,
} from './BaseQuestionGeneration';

/**
 * This custom action is used to send the stats of the question generation after submission
 * like the number of questions generated, the number of questions submitted,
 * the number of questions deleted, the number of questions failed, etc.
 */
class QuestionsSubmittedAction extends BaseQuestionGeneration {
  name = 'Questions Submitted';

  type = ActionDataType.Action;

  prepareTags(
    input: QuestionGenerationInputData & {
      requestedCount: number;
      submittedCount: number;
      deletedCount: number;
    },
  ): Record<string, any> {
    // First get the base tags from parent class
    const baseTags = super.prepareTags(input);

    // Add batch-specific tags
    return {
      ...baseTags,
      [QUESTION_ACTION_TAGS.REQUESTED_COUNT]: input.requestedCount,
      [QUESTION_ACTION_TAGS.SUBMITTED_COUNT]: input.submittedCount,
      [QUESTION_ACTION_TAGS.DELETED_COUNT]: input.deletedCount,
    };
  }
}

export default QuestionsSubmittedAction;
